module.exports = __webpack_public_path__ + "img/bz5.d205a8a4.jpg";